import { Component } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Customer } from '@src/app/models/customer';

@Component({
  selector: 'app-customerportal-light',
  templateUrl: './customerportal-light.component.html',
  styleUrl: './customerportal-light.component.css'
})
export class CustomerportalLightComponent {
  customer: Customer = JSON.parse(SessionHelper.getCustomer());

}
